module.exports = __webpack_public_path__ + "img/fiba-emeklilik.fc10e366.png";